export default [
  {
    text: 'enrollments.table.deviceType',
    value: 'deviceType',
  },
  {
    text: 'enrollments.table.serialNumber',
    value: 'serialNumber',
  },
  {
    text: 'enrollments.table.venue',
    value: 'venue',
    type: 'slot',
  },
  {
    text: 'enrollments.table.appInformation',
    value: 'appInformation',
    type: 'slot',
  },
  {
    text: 'enrollments.table.role',
    value: 'role',
  },
  {
    text: 'enrollments.table.enrollmentStatus',
    value: 'enrollmentStatus',
    type: 'slot',
  },
  {
    text: 'enrollments.table.rolloutStatus',
    value: 'rolloutStatus',
    type: 'slot',
  },
  {
    text: 'enrollments.table.isActive',
    value: 'isActive',
    type: 'slot',
  },
];
